import {
  CalendarDays,
  ChartColumn,
  EyeOff,
  Grid3x3,
  LucideIcon,
  SlidersHorizontal,
} from 'lucide-react';
import { TitleEntry } from '../../../navigation/titleEntry';
import {
  LURKER_CAMERA_DAYS_PATH,
  LURKER_DASHBOARD_PATH,
  LURKER_LABELING_PATH,
  LURKER_RELABEL_PATH,
  LURKER_STRATEGIES_PATH,
} from '../../paths';

/**
 * The one list of Lurker destinations. The sidebar renders it, the mobile topbar
 * takes its label from it, and the browser tab is named from it.
 */
export interface LurkerNavItem {
  label: string;
  icon: LucideIcon;
  path: string;
}

export const LURKER_NAV_ITEMS: LurkerNavItem[] = [
  { label: 'Dashboard', icon: ChartColumn, path: LURKER_DASHBOARD_PATH },
  { label: 'Camera-days', icon: CalendarDays, path: LURKER_CAMERA_DAYS_PATH },
  { label: 'Strategies', icon: SlidersHorizontal, path: LURKER_STRATEGIES_PATH },
  { label: 'OOS Labeling', icon: Grid3x3, path: LURKER_LABELING_PATH },
  { label: 'Relabel', icon: EyeOff, path: LURKER_RELABEL_PATH },
];

export const LURKER_APP_TITLE = 'Lurker';

/** The nav item that owns a path; a camera-day belongs to Camera-days. */
export const lurkerNavItemFor = (pathname: string): LurkerNavItem | undefined =>
  LURKER_NAV_ITEMS.find((item) => pathname === item.path || pathname.startsWith(`${item.path}/`));

/** Top bar title on mobile: the label of the page that owns the path, else 'Lurker'. */
export const getLurkerPageLabel = (pathname: string): string =>
  lurkerNavItemFor(pathname)?.label ?? LURKER_APP_TITLE;

/** Browser tab names for Lurker. */
export const LURKER_TITLE_ENTRIES: TitleEntry[] = [
  ...LURKER_NAV_ITEMS.map((item) => ({ path: item.path, label: item.label })),
  {
    path: `${LURKER_CAMERA_DAYS_PATH}/:cameraDayId/timelines`,
    label: 'Timelines',
    params: [{ name: 'cameraDayId' }],
  },
  {
    path: `${LURKER_CAMERA_DAYS_PATH}/:cameraDayId/images`,
    label: 'Images',
    params: [{ name: 'cameraDayId' }],
  },
  {
    path: `${LURKER_LABELING_PATH}/:batchId`,
    label: 'Batch',
    params: [{ name: 'batchId', opaque: true }],
  },
  {
    path: `${LURKER_RELABEL_PATH}/:sessionId`,
    label: 'Relabel session',
    params: [{ name: 'sessionId', opaque: true }],
  },
];
